const DRAFT = 'DRAFT'
const PENDING = 'PENDING'
const ACCEPTED = 'ACCEPTED'
const BRANCH_IN_PROGRESS = 'BRANCH_IN_PROGRESS'
const BRANCH_IN_PACKAGED = 'BRANCH_IN_PACKAGED'
const BRANCH_SUPPLIED = 'BRANCH_SUPPLIED'
const BRANCH_DISPATCH = 'BRANCH_DISPATCH'
const BRANCH_AVAILABLE_VALE = 'BRANCH_AVAILABLE_VALE'
const DRIVER_IN_BRANCH = 'DRIVER_IN_BRANCH'
const SUPPLIED = 'SUPPLIED'
const ORDER_WAITING = 'ORDER_WAITING'
const TRANSIT = 'TRANSIT'
const ONSITE = 'ONSITE'
const COMPLETED = 'COMPLETED'
const CANCELED = 'CANCELED'
const CANCEL_REQUEST = 'CANCEL_REQUEST'
const COMPLETED_REQUEST = 'COMPLETED_REQUEST'
const SCHEDULE = 'SCHEDULE'

export const object = {
  DRAFT,
  PENDING,
  ACCEPTED,
  BRANCH_IN_PROGRESS,
  BRANCH_IN_PACKAGED,
  BRANCH_SUPPLIED,
  BRANCH_DISPATCH,
  BRANCH_AVAILABLE_VALE,
  DRIVER_IN_BRANCH,
  SUPPLIED,
  ORDER_WAITING,
  TRANSIT,
  ONSITE,
  COMPLETED,
  CANCELED,
  CANCEL_REQUEST,
  COMPLETED_REQUEST,
  SCHEDULE
}

export const array = [
  DRAFT,
  PENDING,
  ACCEPTED,
  SUPPLIED,
  TRANSIT,
  ONSITE,
  COMPLETED,
  CANCELED,
  CANCEL_REQUEST,
  COMPLETED_REQUEST,
  SCHEDULE
]

export const AllInProgress = [
  PENDING,
  ACCEPTED,
  DRIVER_IN_BRANCH,
  BRANCH_DISPATCH,
  SUPPLIED,
  ORDER_WAITING,
  TRANSIT,
  ONSITE
]

export const inProgres = [
  PENDING,
  ACCEPTED,
  BRANCH_DISPATCH,
  DRIVER_IN_BRANCH,
  SUPPLIED,
  TRANSIT,
  ONSITE
]

export const ACCEPTED_STATUS = [
  PENDING,
  ACCEPTED,
  BRANCH_IN_PROGRESS,
  BRANCH_IN_PACKAGED,
  BRANCH_SUPPLIED,
  BRANCH_DISPATCH,
  BRANCH_AVAILABLE_VALE,
  DRIVER_IN_BRANCH,
  SUPPLIED,
  ORDER_WAITING
]

export const completed = [
  COMPLETED,
  COMPLETED_REQUEST,
  CANCELED
]

export const cancelled = [
  CANCELED
]

export const transit = [
  TRANSIT,
  ONSITE
]

export default {
  object,
  array,
  inProgres,
  completed,
  transit,
  cancelled,
  ACCEPTED_STATUS
}
